import { render, staticRenderFns } from "./ReportTicker.vue?vue&type=template&id=170a2438"
import script from "./ReportTicker.vue?vue&type=script&lang=js"
export * from "./ReportTicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports